// -- -- -- -- -- -- -- -- -- -- --
// Init the Slide Function

$( document ).ready(function() { 
	
	
	//console.log('ready');
	
	$(".arrow-up").click(function() {
	  $("html, body").animate({ scrollTop: 0 }, "smooth");
	  return false;
	});
	
	if($('.container-fluid').length){
		var marginL = $('.container').css('margin-left');
		$('.container-fluid').each(function () {
			$(this).find('.row').addClass('justify-content-between');
			$(this).find('.offset-lg-2:first-child').css('margin-left' , marginL);
			$(this).find('.offset-2:nth-child(2)').css('margin-left' , marginL);
			$(this).find('.offset-lg-2').removeClass('offset-lg-2');
		});
		//console.log($('.container').css('margin-left'));
	}
	
	if($('#contact-item-sticky').length){
		$(window).scroll(function() {    
			var scroll = $(window).scrollTop();
			var scrollH = $('.block_schell-header').height();
			var scrollH = scrollH / 2;
			//console.log(scroll);
			//console.log(scrollH);
			if (scroll >=  scrollH) {
				$("#contact-item-sticky").addClass("position-fixed");
			}else{
				$("#contact-item-sticky").removeClass("position-fixed");
			}
		});
	}
	if($('.content-with-sticky .block_schell-stickynav').length){
		$('.content-with-sticky .block_schell').each(function( index ) {
		  $(this).addClass('scroll-margin-top');
		  var navitemid = $(this).attr('id');
		  var navitemtext = $(this).find('.text-stickynav').text();
		  if(navitemtext != ''){
			  var navitem = '<li class="mb-2"><a href="#'+navitemid+'" class="fw-600 text-decoration-none">'+navitemtext+'</a></li>';
				$('.block_schell-stickynav .content-wrapper ul').append(navitem);
		  }
		});
		var headerH = $('.block_schell-header').outerHeight();
		var headerH = headerH;
		$(window).scroll(function() {    
			var scroll = $(window).scrollTop();
			if (scroll >= 1440) {
				$('.content-with-sticky .block_schell-stickynav').not('.specialcase').addClass("position-sticky");
			}else{
				$('.content-with-sticky .block_schell-stickynav').removeClass("position-sticky");
			}
		});
	}
	
	if($('.page-id-17 .content-with-sticky .block_schell-stickynav').length){
		$('.content-with-sticky .block_schell-leistungen .row .offset-2').each(function( index ) {
		  $(this).addClass('scroll-margin-top');
		  var navitemid = $(this).attr('id');
		  var navitemtext = $(this).find('h4').text();
		  if(navitemtext != ''){
			  var navitem = '<li class="mb-2"><a href="#'+navitemid+'" class="fw-600 text-decoration-none">'+navitemtext+'</a></li>';
				$('.block_schell-stickynav .content-wrapper ul').append(navitem);
		  }
		});
	}
	
	if($('.parent-pageid-17 .block_schell-headline-usps').length){
		$('.parent-pageid-17 .block_schell-headline-usps').each(function( index ) {
		  if($(this).find('.accordion .accordion-header h1').text() == ''){
			var trigger = $(this).find('.accordion .accordion-body .bg-gruen').html();
			var triggerMod = '<div class="bg-gruen p-3" style="margin-top:4px;">'+trigger+'</div>';
			$(this).find('.accordion .accordion-header h1').append(triggerMod);
			$(this).find('.accordion .accordion-header h1 p').css('line-height', '27px');
			$(this).find('.accordion .accordion-body .bg-gruen').remove();
		  }
		});
		
		if ($(window).width() < 768) {
		   $('.parent-pageid-17 .block_schell-headline-usps .accordion-header button').click();
		   $('.parent-pageid-17 .block_schell-headline-text-img .accordion-header button').click();
		   $('.parent-pageid-17 .block_schell-headline-text-img .accordion-header .readmore-text').show();
		   $('.parent-pageid-17 .block_schell-headline-text-img .accordion-header .readless-text').hide();
		   $('.parent-pageid-17 .block_schell-headline-usps .accordion-header .readmore-text').show();
		   $('.parent-pageid-17 .block_schell-headline-usps .accordion-header .readless-text').hide();
		}
		
		$('.parent-pageid-17 .block_schell .accordion-header button').click(function(){
			if($(this).hasClass('collapsed')){
				$(this).find('a .readmore-text').show();
				$(this).find('a .readless-text').hide();
			}else{
				$(this).find('a .readmore-text').hide();
				$(this).find('a .readless-text').show();
			}
		});
		
		
		
		$(".parent-pageid-17 .block_schell-headline-text-img").first().find(".accordion-collapse").addClass("show"); 
		$(".parent-pageid-17 .block_schell-headline-text-img").first().find(".accordion-header button").removeClass("collapsed");
		$(".parent-pageid-17 .block_schell-headline-text-img").first().find(".accordion-header button").find('a .readmore-text').hide();
		$(".parent-pageid-17 .block_schell-headline-text-img").first().find(".accordion-header button").find('a .readless-text').show();
		
	}

	
	$(window).scroll(function() {    
		var scroll = $(window).scrollTop();
		if (scroll >= 50) {
			$("#navbar-brand-container").addClass("scrolled-header");
		}else{
			$("#navbar-brand-container").removeClass("scrolled-header");
		}
	});
	
	jQuery(function($) {
		function equalHeight(group) {
			//group.css('height','auto'); 
			var tallest = 0;
			group.each(function() {
			   var thisHeight = $(this).height();
			   if(thisHeight > tallest) {
				  tallest = thisHeight;
			   }
			});
			group.height(tallest);
		}
		
		if ($(window).width() > 767) {
		   equalHeight($(".equalheight"))
		}
		
		function equalMinHeight(group) {
			//group.css('height','auto'); 
			var tallest = 0;
			group.each(function() {
			   var thisHeight = $(this).height();
			   //console.log(thisHeight);
			   if(thisHeight > tallest) {
				  tallest = thisHeight;
			   }
			});
			group.css('min-height' , ''+tallest+'px');
		}
		//if ($(window).width() > 767) {
		   equalMinHeight($(".equalminheight"))
		//}
	
	});
	
	//equalHeight($(".equalheight"));

	
}); 